/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
import slugify from 'slugify';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CurrencyText from './currencyText';

const MenuProductCard = ({ data, brandId, onPress, active, razerCampaignText, brandsContext }) => {
  const [imgClass, setImgClass] = useState('float-end');
  const brandID = brandId || data?.brandCrmId;
  const productName = data?.name;
  const productImage =
    data?.productImage?.media?.url ||
    data?.media?.path ||
    data?.productMedia?.path ||
    data?.productImage?.Media?.Url ||
    'no-image-src';
  const siteBaseUrl = process.env.SITE_URL;

  function onProductCardClick() {
    window?.dataLayer?.push({
      cd_pageType: 'detay sayfası',
    });

    window.location.href = `${siteBaseUrl}/${
      brandsContext.find((brand) => brand.node.CRMId === brandID).node.NormalizedName
    }/${slugify(data.name.split('®').join(''), {
      lower: true,
      strict: true,
    })}`;
  }

  function handleDataRouting() {
    return `${siteBaseUrl}/${
      brandsContext?.find((brand) => brand?.node?.CRMId === brandID)?.node?.NormalizedName
    }/${slugify(data?.name?.split('®')?.join('') || '', {
      lower: true,
      strict: true,
    })}`;
  }

  const productsByBrand = data?.apiProducts?.filter((brand) => brand?.brandId === brandID)?.[0]?.products;

  let productPrice = null;
  function getProductPrice(productId) {
    for (let i = 0; i < productsByBrand?.length; i += 1) {
      const subcategories = productsByBrand?.[i]?.subcategories;
      for (let k = 0; k < subcategories?.length; k += 1) {
        const products = subcategories?.[k]?.products;
        productPrice = products?.find((item) => item?.value === productId)?.price;
        if (productPrice !== undefined) return productPrice;
      }
    }
    return null;
  }

  return (
    <a href={handleDataRouting()} title={productName} className="product-link">
      <Card
        key={`key-${data?.value || data?.crmId}`}
        className="menu-product-card"
        onClick={() => onProductCardClick()}
        data-routing={handleDataRouting()}
      >
        <div className="product-card-body">
          <div className="product-content">{active ? <h3>{productName}</h3> : <span>{productName}</span>}</div>
          <div className="product-img-wrapper">
            <LazyLoadImage
              threshold={50}
              width="100%"
              height="150"
              className={imgClass}
              alt={productName}
              src={productImage}
              onError={() => {
                setImgClass('img-none');
              }}
              loading="lazy"
            />
          </div>
          <div className={!razerCampaignText ? 'bottom-wrapper' : 'bottom-wrapper-for-razer-gold'}>
            <span className="product-price">
              <CurrencyText enableTheme>{data?.price || getProductPrice(data?.crmId)}</CurrencyText>
            </span>
            <Button className="add-button" onClick={onPress ? () => onPress(data) : onProductCardClick}>
              <span>
                <i className="icon-Basket" />
              </span>
              <div className={!razerCampaignText ? 'add-button-badge' : 'add-button-badge-for-razer'}>
                <i className="icon-Add" />
              </div>
            </Button>
          </div>
        </div>
        {!!razerCampaignText && (
          <a className="razer-gold-wrapper" href="/razer-gold">
            <div className="razer-gold-container">
              <div className="icon-container">
                <i className="icon-gamer razer-icon" />
              </div>
              <p className="razer-gold-text">{razerCampaignText}</p>
              <div className="arrow-icon-container">
                <i className="icon-Arrow_simple_rightt arrow_icon" />
              </div>
            </div>
          </a>
        )}
      </Card>
    </a>
  );
};

MenuProductCard.propTypes = {
  data: PropTypes.object,
  brandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPress: PropTypes.func,
  active: PropTypes.bool,
  razerCampaignText: PropTypes.string,
  brandsContext: PropTypes.array,
};

export default MenuProductCard;
